import { PageListDataSource } from './BaseDataSources';
import { ILoanAssetType } from '../Interfaces';

export class StripTypesSource extends PageListDataSource<ILoanAssetType> {
  public constructor() {
    super('/datasource/striptypes');
  }
}